import { apiAxios } from '@/api/axios';
import type {
  AdminUserCreate,
  AdminUserDto,
  AdminUserUpdate,
} from '@/api/types/AdminUser';

// Admin users service — wraps `/api/admin/users/*` (§4.4). Functional, one
// export per endpoint; mirrors `ordersService.ts` style. List is unpaged —
// realistic user count is <50, client-side filter is acceptable per UI-05.

export const listUsers = async (): Promise<AdminUserDto[]> => {
  const response = await apiAxios.get<AdminUserDto[]>('/api/admin/users');
  return response.data;
};

export const createUser = async (payload: AdminUserCreate): Promise<AdminUserDto> => {
  const response = await apiAxios.post<AdminUserDto>('/api/admin/users', payload);
  return response.data;
};

export const updateUser = async (
  sub: string,
  payload: AdminUserUpdate,
): Promise<AdminUserDto> => {
  const response = await apiAxios.patch<AdminUserDto>(
    `/api/admin/users/${sub}`,
    payload,
  );
  return response.data;
};

export const deactivateUser = async (sub: string): Promise<AdminUserDto> => {
  const response = await apiAxios.post<AdminUserDto>(
    `/api/admin/users/${sub}/deactivate`,
  );
  return response.data;
};

export const activateUser = async (sub: string): Promise<AdminUserDto> => {
  const response = await apiAxios.post<AdminUserDto>(
    `/api/admin/users/${sub}/activate`,
  );
  return response.data;
};

export const resendInvite = async (sub: string): Promise<void> => {
  await apiAxios.post(`/api/admin/users/${sub}/resend-invite`);
};
